import { noop } from 'lodash';
import { RefObject, createContext, useContext } from 'react';

import { PageLayoutProps, PageLayoutWidth } from './PageLayout.types';

export const pageLayoutPrivateContextDefault = {
  isPanelExternallyControlled: false,
  isPanelOpen: false,
  closePanel: noop,
  openPanel: noop,
};

const PageLayoutPrivateContext = createContext<PageLayoutPrivateContextProps>(pageLayoutPrivateContextDefault);

export default PageLayoutPrivateContext;

export interface PageLayoutPrivateContextProps
  extends Pick<
    PageLayoutProps,
    | 'closeContentSidebarAriaLabel'
    | 'collapseLeftSidebar'
    | 'noScroll'
    | 'noSpacing'
    | 'onPageLayoutContentRendered'
    | 'onRenderSubHeader'
    | 'showContentSidebarAriaLabel'
    | 'suppressTopPadding'
    | 'fullWidthLayout'
  > {
  readonly hasBanner?: boolean;
  readonly hasHeader?: boolean;
  readonly hasLeftSidebar?: boolean;
  readonly isPanelExternallyControlled?: boolean;
  readonly isPanelOpen: boolean;
  readonly showContentPanelButtonForWidths?: PageLayoutWidth[];
  readonly showLeftSidebar?: boolean;
  readonly showSubHeader?: boolean;
  readonly topOffset?: number;
  readonly width?: PageLayoutWidth;
  readonly hasFooter?: boolean;
  readonly ref?: RefObject<HTMLDivElement>;
  closePanel(): void;
  openPanel(): void;
}

export type UsePageLayoutPrivateContext = () => PageLayoutPrivateContextProps;
export const usePageLayoutPrivateContext: UsePageLayoutPrivateContext = () =>
  useContext<PageLayoutPrivateContextProps>(PageLayoutPrivateContext);
